import { GetJobUtterancesResponseDto } from 'app/API';
import { ResponsivePanels } from '@components/ResponsivePanels';
import { useState } from 'react';
import { TranscriptLayout } from '../TranscriptLayout';

type TProps = {
  primaryUtterances: GetJobUtterancesResponseDto['utterances'];
  compareUtterances: GetJobUtterancesResponseDto['utterances'];
  primaryTitle: string;
  compareTitle: string;
  playbackTime: number;
  onWordClick: (timestamp: number) => void;
  followPlayScroll: boolean;
  searchFocusSignal?: number;
};

export const SplitTranscriptLayout = ({
  primaryUtterances,
  compareUtterances,
  primaryTitle,
  compareTitle,
  playbackTime,
  onWordClick,
  followPlayScroll,
  searchFocusSignal,
}: TProps) => {
  const [activePane, setActivePane] = useState<'primary' | 'compare'>('primary');

  return (
    <div className="mt-[var(--transcript-toolbar-clearance,6rem)] min-w-0">
      <ResponsivePanels
        activePanel={activePane === 'primary' ? 'first' : 'second'}
        onPanelChange={(panel) => setActivePane(panel === 'first' ? 'primary' : 'compare')}
        firstLabel={primaryTitle}
        secondLabel={compareTitle}
        first={
          <section
            className="min-w-0 rounded-lg border border-border bg-[var(--color-surface)] p-4 shadow-sm"
            onPointerDown={() => setActivePane('primary')}
          >
            <TranscriptLayout
              utterances={primaryUtterances}
              playbackTime={playbackTime}
              onWordClick={onWordClick}
              searchNamePrefix="primary"
              searchFocusSignal={searchFocusSignal}
              searchFocusEnabled={activePane === 'primary'}
              onSearchActivate={() => setActivePane('primary')}
              className="mt-0 pr-2"
              height="calc(100dvh - 12rem)"
              title={primaryTitle}
              autoScrollActiveWord={followPlayScroll}
            />
          </section>
        }
        second={
          <section
            className="min-w-0 rounded-lg border border-border bg-[var(--color-surface)] p-4 shadow-sm"
            onPointerDown={() => setActivePane('compare')}
          >
            <TranscriptLayout
              utterances={compareUtterances}
              playbackTime={playbackTime}
              onWordClick={onWordClick}
              searchNamePrefix="compare"
              searchFocusSignal={searchFocusSignal}
              searchFocusEnabled={activePane === 'compare'}
              onSearchActivate={() => setActivePane('compare')}
              className="mt-0 pr-2"
              height="calc(100dvh - 12rem)"
              title={compareTitle}
              autoScrollActiveWord={followPlayScroll}
            />
          </section>
        }
      />
    </div>
  );
};
